var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "sub-nav" }, [
    _c("p", { staticClass: "sub-nav__title strong-medium-mobile" }, [
      _vm._v(_vm._s(_vm.title))
    ]),
    _c(
      "div",
      { staticClass: "u-hidden-tablet-up" },
      [
        _c("select-input", {
          attrs: {
            options: _vm.options,
            selected: _vm.pagePath,
            placeholder: _vm.placeholder
          },
          on: { input: _vm.triggerMobileLink }
        })
      ],
      1
    ),
    _c("div", { staticClass: "u-hidden-mobile-only" }, [
      _c(
        "ul",
        { staticClass: "sub-nav__list" },
        _vm._l(_vm.options, function(option, index) {
          return _c("li", { key: index, staticClass: "sub-nav__list-item" }, [
            option.value === _vm.pagePath
              ? _c("span", { staticClass: "strong-bold sub-nav__link" }, [
                  _vm._v(_vm._s(option.label))
                ])
              : _c(
                  "a",
                  {
                    staticClass: "sub-nav__link link link--primary",
                    attrs: { href: option.value }
                  },
                  [
                    _c("span", { staticClass: "link__content" }, [
                      _vm._v(_vm._s(option.label))
                    ])
                  ]
                )
          ])
        }),
        0
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }